
import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import BaseSearch from './BaseSearch'
import {
  fetchResultSearch,
  clearSearch,
  setFilterChanged,
  resetState,
  SearchFiltered
} from '../ducks'
import { Sidebar, NotFound, SearchTitle } from '..'

import InfiniteScroll from 'react-infinite-scroller'
import { Button } from 'loyal-react'
import { setMetadata } from 'Shared/HeadMetadata/ducks'
import MediaQuery from 'react-responsive'

import '@loyal_template/search.css'
import { ProductCardContainer } from 'Catalog/Product/ProductCard'
import titleName from './Title'
import Helmet from 'react-helmet'
// Main component logic based on search
const MainComponent = ({
  products,
  isSearch,
  hasMoreItems,
  loadItems,
  notFound
}) => {
  if (notFound) {
    return <NotFound isSearch={isSearch} />
  } else {
    return (
      <InfiniteScroll
        initialLoad={false}
        pageStart={0}
        loadMore={loadItems}
        hasMore={hasMoreItems}
        loader={<Button loading text='Carregando' className='btn-flat' />}
      >
        <div className='row'>
          {products.map(product => (
            <Fragment>
              <MediaQuery minDeviceWidth={426}>
                <ProductCardContainer
                  className='col-6 col-lg-4 mb-2 px-1 d-md-block'
                  sku={product.sku}
                  key={product.sku}
                />
              </MediaQuery>
              <MediaQuery maxDeviceWidth={425}>
                <ProductCardContainer
                  isResponsiveEnabled
                  className='col-12 mb-1 px-half d-block card-mobile'
                  sku={product.sku}
                  key={product.sku + '_mobile'}
                />
              </MediaQuery>
            </Fragment>
          ))}
        </div>
      </InfiniteScroll>
    )
  }
}

MainComponent.propTypes = {
  products: PropTypes.object,
  hasMoreItems: PropTypes.func,
  isSearch: PropTypes.bool,
  loadItems: PropTypes.func,
  notFound: PropTypes.bool
}

class SearchVendor extends BaseSearch {
  componentWillMount () {
    this.props.resetState()
    if (this.props.filterSelected) {
      this.props.filterSelected.maxprice = 0
      this.props.filterSelected.minprice = 0
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    const propsChanged =
      JSON.stringify(nextProps) !== JSON.stringify(this.props)
    const stateChanged =
      JSON.stringify(nextState) !== JSON.stringify(this.state)

    return propsChanged || stateChanged
  }

  render () {
    const {
      products,
      subcategories,
      filterSelected,
      isLoading,
      hasNoProducts,
      hasMoreItems
    } = this.props
    const { term } = filterSelected
    const isSearch = !!term
    const notFound = !isLoading && hasNoProducts
    const ariaLabel = 'Resultado da busca'
    let title = ''

    title = this.titleConstructor(this.props.vendors, filterSelected)
    return (
      <Fragment>
        <Helmet>
          <title>{`Resultado de busca - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='searchpage-file container-fluid'>
          <input
            type='text'
            autoFocus
            style={{ width: '1px', height: '1px' }}
            aria-label={ariaLabel}
            readOnly
          />

          <div className='container mt-0'>
            <div className='row'>
              <SearchTitle
                title={title}
                isSearch={isSearch}
                isLoading={isLoading}
                quantityFoundProducts={this.props.quantityFoundProducts}
                className={`${
                  !this.state.condition ? 'd-flex d-md-flex' : 'd-none d-md-flex'
                }`}
              />
              <div
                className={`col-12 px-0 pt-0 pt-md-2 pb-2 ${
                  this.state.condition ? 'd-block d-md-none' : 'd-none d-md-none'
                }`}
              >
                <div className='row'>
                  <div className='col-12 px-0'>
                    <Button
                      id={'button-voltar-mobile'}
                      name={'BUTTON'}
                      text='Voltar'
                      iconName='icon_left icon-sm'
                      className='col-12 btn-sm btn-flat'
                      onClick={this.handleFilter}
                    />
                  </div>
                </div>
              </div>
              <div
                className={`float-button bg-white px-2 py-2 row mx-0 ${
                  this.state.condition ? 'd-block d-md-none' : 'd-none d-md-none'
                }`}
              >
                <div className='col-12 px-0'>
                  <Button
                    className='btn btn-sm btn-featured'
                    text='Aplicar'
                    onClick={this.handleFilter}
                  />
                </div>
              </div>
              <div
                className={`col-12 px-0 pt-0 pb-2 ${
                  !this.state.condition ? 'd-block d-md-none' : 'd-none d-md-none'
                }`}
              >
                <Button
                  id={'button-filtrar-mobile'}
                  name={'BUTTON'}
                  text='Filtrar'
                  iconName='icon_filter'
                  className='col-12 btn-sm '
                  onClick={this.handleFilter}
                />
              </div>
              <Sidebar
                subcategories={subcategories}
                brands={this.props.brands}
                vendors={this.props.vendors}
                features={this.props.features}
                handleFilterChanged={this.handleFilterChanged}
                handleFilterClean={this.handleFilterClean}
                filterSelected={filterSelected}
                priceLimit={this.props.priceLimit}
                pageType='vendor'
                isLoading={isLoading}
                ordination={this.state.ordination}
                className={`${
                  this.state.condition
                    ? 'd-block d-md-block'
                    : 'd-none d-md-block'
                }`}
              />
              <div
                className={`container-card col-12 col-md-8 col-lg-9 pb-5 px-half px-md-1 ${
                  !this.state.condition
                    ? 'd-block d-md-block'
                    : 'd-none d-md-block'
                }`}
              >
                <MainComponent
                  products={products}
                  hasMoreItems={hasMoreItems}
                  isSearch={isSearch}
                  loadItems={this.loadItems}
                  notFound={notFound}
                />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
  titleConstructor = (vendors, filterSelected) => {
    if (!vendors || vendors.length <= 0) {
      return ''
    } else if (filterSelected.vendor.length === 1) {
      return titleName(this.props.vendors, filterSelected.vendor[0])
    }
    return ''
  }
}

const mapStateToProps = ({ searchResult, router }) => ({
  ...SearchFiltered(searchResult, router)
})

const mapDispatchToProps = dispatch => ({
  fetchResultSearch: (
    term,
    identifier,
    type,
    brands,
    categories,
    subcategories,
    vendors,
    vendortype,
    features,
    minprice,
    maxprice,
    sort,
    pageIndex
  ) =>
    dispatch(
      fetchResultSearch(null)(
        term,
        identifier,
        type,
        brands,
        categories,
        subcategories,
        vendors,
        vendortype,
        features,
        minprice,
        maxprice,
        sort,
        pageIndex
      )
    ),
  clearSearch: () => dispatch(clearSearch()),
  resetState: () => dispatch(resetState()),
  setFilterChanged: (filterName, filterSelected) =>
    dispatch(setFilterChanged(filterName, filterSelected)),
  setMeta: (title, description, keywords) =>
    dispatch(setMetadata(title, description, keywords))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchVendor)



// WEBPACK FOOTER //
// ./src/Catalog/Search/Search/SearchVendor.js